export default __webpack_public_path__ + "static/media/leetcode.3e05c90b.png";